<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    v-b-tooltip.hover.v-danger.top="$t(i18nHoverVariable)"
    variant="flat-danger"
    class="btn-icon rounded-circle"
    @click="$emit('clicked')"
  >
    <feather-icon icon="XCircleIcon" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'RejectButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    i18nHoverVariable: {
      type: String,
      default: 'declaration.reject',
    },
  },
}
</script>

<style scoped>

</style>
